import { gql } from '@apollo/client';
import { ScheduleFieldsFragment } from './fragments';

export default gql`
  mutation updateSchedule($input: ScheduleInput!, $id: ID!) {
    updateSchedule(input: $input, id: $id) {
      schedule {
        ...ScheduleFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ScheduleFieldsFragment}
`;
